import { Action } from '@ngrx/store';

export const CITY_MARK_SHOWN_NO_DELIVERY = '[CustomCity] Mark Not Shown No Delivery';

export class CityMarkNotShownNoDelivery implements Action {
  readonly type = CITY_MARK_SHOWN_NO_DELIVERY;
}

// action types
export type CityAction = CityMarkNotShownNoDelivery;
